module.exports = __webpack_public_path__ + "static/media/tramite.e84a6bb4.png";